import { axiosAccount } from "./ApiServices";

export const Signout = async (): Promise<any> => {
  return axiosAccount.post(`/logout`);
};
